import PropTypes from "prop-types"
import React from "react"

import { Box } from "../../../../components/shared/Layout"
import Typography from "../../../../components/shared/Typography"

const BlogPostsEditor = ({ onCancel, practice }) => {
  const posts = practice?.blogPosts || practice?.blog_posts || []
  const pageTitle = practice?.blogPageTitle || practice?.blog_page_title || "Blog"

  return (
    <div className="flex min-h-full flex-col">
      <Box className="flex-1 space-y-6 p-6">
        <div className="rounded-lg border border-builder-border-light bg-[#f4f7f9] p-4">
          <Typography variant="body" className="font-semibold text-builder-primary">
            Managed in Blog admin
          </Typography>
          <Typography variant="body" className="mt-2 text-gray-dark">
            This section mirrors your public <span className="font-medium">/blog</span> page — post list, tags, and
            filters. Edit posts, publish dates, and cover images in Blog admin, not in the section builder.
          </Typography>
        </div>

        <div className="space-y-2">
          <Typography variant="small" className="font-bold uppercase tracking-wide text-gray">
            Page title on /blog
          </Typography>
          <Typography variant="body" className="text-builder-primary">
            {pageTitle}
          </Typography>
          <Typography variant="small" className="text-gray">
            Change this with the page gear icon (Edit page) or in Blog admin.
          </Typography>
        </div>

        <div className="space-y-2">
          <Typography variant="small" className="font-bold uppercase tracking-wide text-gray">
            Published posts
          </Typography>
          <Typography variant="body" className="text-builder-primary">
            {posts.length} {posts.length === 1 ? "post" : "posts"} showing in preview
          </Typography>
        </div>

        <a
          href="/portal/website/blog"
          className="flex h-12 w-full items-center justify-center rounded border border-teal bg-teal px-4 text-center font-bold text-white hover:shadow active:bg-teal-dark">
          Open Blog admin
        </a>
      </Box>

      <div className="sticky bottom-0 border-t border-builder-border-light bg-white px-8 py-6">
        <div className="flex justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="rounded border border-builder-border px-4 py-2 text-base font-bold text-builder-primary transition-colors hover:bg-gray-50">
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

BlogPostsEditor.propTypes = {
  onCancel: PropTypes.func.isRequired,
  practice: PropTypes.object
}

export default BlogPostsEditor
